export { default } from '@shikijs/langs/git-commit'
